import { render, staticRenderFns } from "./editFreightDialog.vue?vue&type=template&id=f8e61de2&scoped=true"
import script from "./editFreightDialog.vue?vue&type=script&lang=js"
export * from "./editFreightDialog.vue?vue&type=script&lang=js"
import style0 from "./editFreightDialog.vue?vue&type=style&index=0&id=f8e61de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e61de2",
  null
  
)

export default component.exports